// React.
import { useContext, useMemo } from 'react';

// Types.
import { BlockingSessionTime } from '../../../types/instance/BlockingSession';

// Components.
import HighchartsWithData from '../../../component/HighchartsWithData';

// Helpers.
import { getConvertedTimeToUTC, highchartsCredits } from '../../../helpers/utils';
import { chartOptionsGranularity } from "../../../helpers/chartOptionsIncreasedGranularity";

// Context
import { TimeRangeContext } from "../../../context/TimeRangeContext";
import { useLicences } from "../../../context/LicenceContext";
import { CHART_DATA_TYPE } from "../../Constants";
import Helper from "../../../helpers/Helper";

export default function BlockingSessionsChart(props: {
    error: string | null,
    loading: boolean,
    data: BlockingSessionTime[],
    applyPeriod: Function
}) {
    const { error, loading, data } = props;
    const { licences } = useLicences();
    const timeRangeContext = useContext(TimeRangeContext)

    const options = useMemo(() => {
            return chartOptionsGranularity(props.applyPeriod, [
                {
                    name: 'Blocking Time',
                    data: data.map(item => {
                        return [getConvertedTimeToUTC(item), item['waittime']]
                    })
                }
            ], null, {
                credits: { enabled: highchartsCredits(licences) },
                timeRangeContext: timeRangeContext,
                tooltip: {
                    useHTML: true,
                    formatter: function () {
                        return Helper.getChartTooltipsNew(this, CHART_DATA_TYPE.TIME);
                    },
                },
                legend: true,
                plotLines: [],
                plotBands: [],
                yAxis: [{
                    title: {
                        text: 'Duration'
                    },
                    labels: {
                        formatter: function (): string {
                            // @ts-ignore
                            return Helper.getTimeInEnglish(this?.value);
                        }
                    },
                    min: 0,
                }]
            })
        },
        [data, licences, timeRangeContext]);

    return (
        <div className="card collapsible">
            <div className="card-header">
                <i className="fal fa-chart-bar fa-fw" aria-hidden="true"/>
                Blocking time
                <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                   data-bs-target="#collapse-space" aria-expanded="false"
                   aria-controls="collapse-space"/>
            </div>
            <div id="collapse-space" className="card-body collapse show">
                <HighchartsWithData error={error} loading={loading}
                                    length={data.length} options={options}/>
            </div>
        </div>
    )
}
